import { render, staticRenderFns } from "./PasswordResetSuccess.vue?vue&type=template&id=73f14cd9&scoped=true&"
import script from "./PasswordResetSuccess.vue?vue&type=script&lang=js&"
export * from "./PasswordResetSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f14cd9",
  null
  
)

export default component.exports